<template>
  <div>
    <heading><small>Edit profile</small></heading>
    <form-message severity="warning"
                  :message="error" />
    <profile-form v-if="profile"
                  :email="profile.email"
                  :givenName="profile.given_name"
                  :familyName="profile.family_name"
                  :emailDisabled="true"
                  submitText="Save"
                  @submit="updateProfile" />
    <form-button pull="left"
                 @click="$router.go(-1)">
      Cancel
    </form-button>
    <div class="email-disabled-note">
      <p>
        <small>
          <strong>Note:</strong>
          Changing your email is unfortunately not yet possible via your account
          settings, but you can get help with this by contacting support.
        </small>
      </p>
    </div>
  </div>
</template>

<script>
import {
  getUserProfile,
  setUserProfile,
} from '../auth';

import Heading from './elements/Heading';
import FormButton from './elements/FormButton';
import FormMessage from './elements/FormMessage';
import ProfileForm from './forms/Profile';

export default {
  components: {
    Heading,
    FormButton,
    FormMessage,
    ProfileForm,
  },

  data() {
    return {
      deleteConfirmed: false,
      profile: null,
      error: null,
    };
  },

  created() {
    getUserProfile({
      success: (result) => {
        this.profile = result;
      },
      error: (error) => {
        this.error = error;
      },
    });
  },

  methods: {
    updateProfile({ givenName, familyName }) {
      setUserProfile({
        given_name: givenName,
        family_name: familyName,
        success: () => {
          this.$router.push('/');
        },
        error: (error) => {
          this.error = error;
        },
      });
    },
  },
};
</script>

<style scoped>
.email-disabled-note:before {
  content: '';
  display: block;
  clear: both;
}
.email-disabled-note {
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/EditProfile.vue